
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import onClickOutside from 'react-onclickoutside';
import Autosuggest from 'react-autosuggest';

import Translatable from '../../../../../Translatable';

import {
    display,
    input,
    position,
    width
} from '../../../../../../commonStyles.js';
import styles from '../styles.js';

class TagInput extends Component {
    static propTypes = {
        getSuggestionValue: PropTypes.func.isRequired,
        onHideTagInput: PropTypes.func.isRequired,
        onShowTagInput: PropTypes.func.isRequired,
        onSuggestionSelected: PropTypes.func.isRequired,
        onSuggestionsClearRequested: PropTypes.func.isRequired,
        onSuggestionsFetchRequested: PropTypes.func.isRequired,
        onTagChange: PropTypes.func.isRequired,
        renderSuggestion: PropTypes.func.isRequired,
        suggestions: PropTypes.array.isRequired,
        tagInput: PropTypes.object.isRequired,
        tagLabel: PropTypes.string
    }

    handleClickOutside = () => {
        const { onHideTagInput } = this.props;
        onHideTagInput();
    }

    shouldRenderSuggestions = () => {
        return true;
    }

    render() {
        const { shouldRenderSuggestions } = this;
        const {
            getSuggestionValue,
            onHideTagInput,
            onShowTagInput,
            onTagChange,
            onSuggestionSelected,
            onSuggestionsFetchRequested,
            onSuggestionsClearRequested,
            renderSuggestion,
            suggestions,
            tagInput,
            tagLabel
        } = this.props;
        const inputProps = {
            value: tagLabel ? tagLabel : '',
            onChange: onTagChange,
            onBlur: onHideTagInput,
            onFocus: onShowTagInput
        };
        return (
            <div id="tags_input">
                <div className={css(position.relative)}>
                    <div className={css(display.block, width.fullWidth)}>
                        <label
                            className={css(styles.hiddenLabel)}
                            htmlFor="tags_SearchBarLarge"
                        >
                            <Translatable
                                content={{
                                    transKey: 'common.what'
                                }}
                            />
                        </label>
                        <div className={css(styles.container, styles.container_noMargins)}>
                            <div
                                style={{
                                    display: 'table'
                                }}
                            >
                                <div
                                    style={{
                                        display: 'table-cell',
                                        verticalAlign: 'middle'
                                    }}
                                >
                                    <div className={css(styles.prefixContainer)}>
                                        <div className={css(styles.prefix)}>
                                            <div>
                                                <svg
                                                    viewBox="0 0 24 24"
                                                    role="presentation"
                                                    aria-hidden="true"
                                                    focusable="false"
                                                    style={{
                                                        display: 'block',
                                                        fill: 'rgb(118, 118, 118)',
                                                        height: '18px',
                                                        width: '18px'
                                                    }}
                                                >
                                                    <path
                                                        d="M10.4 18.2c-4.2-.6-7.2-4.5-6.6-8.8.6-4.2 4.5-7.2 8.8-6.6 4.2.6 7.2 4.5 6.6 8.8-.6 4.2-4.6 7.2-8.8 6.6M23 22l-5-5c1.4-1.4 2.3-3.1 2.6-5.2.7-5.1-2.8-9.7-7.8-10.5-5-.7-9.7 2.8-10.5 7.9-.7 5.1 2.8 9.7 7.8 10.5 2.5.4 4.9-.3 6.7-1.7v.1l5 5c.3.3.8.3 1.1 0 .3-.3.4-.8.1-1.1"
                                                        fillRule="evenodd"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    id="tagsAutocomplete"
                                    style={{
                                        display: 'table-cell',
                                        verticalAlign: 'middle'
                                    }}
                                >
                                    <Translatable
                                        nestedAttributes={{
                                            inputProps: {
                                                placeholder: {
                                                    transKey: 'common.what'
                                                }
                                            }
                                        }}
                                    >
                                        <Autosuggest
                                            suggestions={suggestions}
                                            shouldRenderSuggestions={shouldRenderSuggestions}
                                            onSuggestionSelected={onSuggestionSelected}
                                            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                                            onSuggestionsClearRequested={onSuggestionsClearRequested}
                                            getSuggestionValue={getSuggestionValue}
                                            renderSuggestion={renderSuggestion}
                                            inputProps={inputProps}
                                            theme={
                                                tagInput.visible ?
                                                    {
                                                        container: {
                                                            position: 'relative'
                                                        },
                                                        input: {
                                                            fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
                                                            fontSize: '15px',
                                                            lineHeight: '18px',
                                                            letterSpacing: '0.2px',
                                                            paddingTop: '0px',
                                                            paddingBottom: '0px',
                                                            color: '#484848',
                                                            backgroundColor: 'transparent',
                                                            border: '0px',
                                                            padding: '11px',
                                                            width: '100%',
                                                            textOverflow: 'ellipsis',
                                                            outline: 'none'
                                                        },
                                                        inputFocused: {
                                                            width: '100%'
                                                        },
                                                        suggestionsContainer: {
                                                            backgroundColor: 'rgb(255, 255, 255)',
                                                            marginTop: '0px',
                                                            position: 'absolute',
                                                            borderColor: 'rgb(219, 219, 219)',
                                                            borderRadius: '0px 0px 2px 2px',
                                                            borderStyle: 'solid',
                                                            borderWidth: '1px',
                                                            padding: '0px',
                                                            overflow: 'hidden',
                                                            width: '572px',
                                                            left: '-32px',
                                                            top: '42px'
                                                        },
                                                        suggestionHighlighted: {
                                                            backgroundColor: '#fafafa'
                                                        },
                                                        suggestionsList: {
                                                            padding: 0
                                                        },
                                                        suggestion: {
                                                            cursor: 'pointer',
                                                            display: 'table',
                                                            listStyleType: 'none',
                                                            width: '100%',
                                                            outline: 'none',
                                                            padding: '8px 12px'
                                                        }
                                                    } :
                                                    {
                                                        container: {
                                                            position: 'relative'
                                                        },
                                                        input: {
                                                            fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
                                                            fontSize: '15px',
                                                            lineHeight: '18px',
                                                            letterSpacing: '0.2px',
                                                            paddingTop: '0px',
                                                            paddingBottom: '0px',
                                                            color: '#484848',
                                                            backgroundColor: 'transparent',
                                                            border: '0px',
                                                            padding: '11px',
                                                            width: '100%',
                                                            textOverflow: 'ellipsis',
                                                            outline: 'none'
                                                        },
                                                        inputFocused: {
                                                            width: '100%'
                                                        },
                                                        suggestionsContainer: {
                                                            backgroundColor: 'rgb(255, 255, 255)',
                                                            marginTop: '0px',
                                                            position: 'absolute',
                                                            borderColor: 'rgb(219, 219, 219)',
                                                            borderRadius: '0px 0px 2px 2px',
                                                            borderStyle: 'solid',
                                                            borderWidth: '0px',
                                                            padding: '0px',
                                                            overflow: 'hidden',
                                                            width: '572px',
                                                            left: '-32px',
                                                            top: '42px'
                                                        },
                                                        suggestionHighlighted: {
                                                            backgroundColor: '#fafafa'
                                                        },
                                                        suggestionsList: {
                                                            padding: '0px',
                                                            margin: '0px'
                                                        },
                                                        suggestion: {
                                                            cursor: 'pointer',
                                                            display: 'table',
                                                            listStyleType: 'none',
                                                            width: '100%',
                                                            outline: 'none',
                                                            padding: '8px 12px'
                                                        }
                                                    }
                                            }
                                        />
                                    </Translatable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className={
                        tagInput.visible ?
                            css(input.focusUnderline, styles.showUnderline) :
                            css(input.focusUnderline)
                    }
                />
            </div>
        );
    }
}

export default onClickOutside(TagInput);



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarLarge/TagInput/TagInput.jsx